module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9x3Rv"))).then(() => parcelRequire('1iHdE'));